<template>
  <component :is="view" />
</template>
<script>

// /dashboard 的分流：v2.3 看板（地址以 v2_3- 开头）用带刷新按钮的 IframeDashboardFresh，其余照旧用 IframeDashboard。
// 全量切换时把 isFresh 改成恒 true；回滚时把 paths.js 里 /dashboard 的 view 改回 IframeDashboard。
import IframeDashboard from './IframeDashboard.vue';
import IframeDashboardFresh from './IframeDashboardFresh.vue';

function isFresh(url) {
  return url.indexOf('v2_3-') === 0;
}

export default {
  name: "DashboardSelector",
  data: () => ({
    view: null,
  }),
  created() {
    let url = '';
    try {
      url = JSON.parse(sessionStorage.getItem('USER')).user.url.trim();
    } catch (e) {
      // 没登录信息：交给 IframeDashboard 原有逻辑跳回 /list
    }
    this.view = isFresh(url) ? IframeDashboardFresh : IframeDashboard;
  }
}
</script>
